document.addEventListener('DOMContentLoaded', comparisonAltInit);

function comparisonAltInit() {
  const comparisons = document.querySelectorAll('.comparison-alt');
  for (const comparison of comparisons) {
    const scroller = comparison.querySelector('.overflow-scroll');
    if (!scroller) continue;

    const wrapper = scroller.closest('.row');
    if (!wrapper) continue;

    scroller.addEventListener('scroll', () => updateScrollState(scroller, wrapper));
    window.addEventListener('resize', () => updateScrollState(scroller, wrapper));

    updateScrollState(scroller, wrapper);
  }
}

function updateScrollState(scroller, wrapper) {
  const { scrollLeft, clientWidth, scrollWidth } = scroller;

  const hasOverflow = scrollWidth > clientWidth + 1;
  const atEnd = scrollLeft + clientWidth >= scrollWidth - 1;

  wrapper.classList.toggle('shadow-right', hasOverflow && !atEnd);
  wrapper.classList.toggle('has-overflow', hasOverflow);
  wrapper.classList.toggle('is-scrolled', scrollLeft > 0);
}
